<script>

import { Overlay } from '../../'
import {drawIndicatorPlot} from '../../workspace/indicator-plots.mjs'

export default {
    name: 'Crossover',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'Mano', version: '1.0.0',
                desc: 'SMA Crossover',
                preset: {
                    name: 'SMA Crossover $slowLength $fastLength',
                    side: 'onchart',
                    settings: {
                        lineWidth: 1.5,
                        topColor: 'rgba(0, 128, 0, 0.6)',
                        bottomColor: 'rgba(255, 0, 0, 0.6)',
                        color: 'rgba(220, 220, 220, 0.1)',
                        showMid: true,
                        backColor: 'rgba(215, 215, 215, 0.1)'
                    }
                }
            }
        },
        draw(ctx){
            const settings=this.settings,layout=this.layout;
            const data=this.data.map(row=>row.length>3?[row[0],row[3],row[1]]:row);
            drawIndicatorPlot(ctx,data,layout,settings,0,{color:settings.fastColor||'#2962ff'});
            drawIndicatorPlot(ctx,data,layout,settings,1,{color:settings.slowColor||'#ff6d00'});
            if(settings.showCrosses!==false){
                ctx.save();ctx.strokeStyle=settings.crossColor||'#2962ff';ctx.lineWidth=2;
                for(let index=1;index<data.length;index++){
                    const before=data[index-1],after=data[index];if(![before[1],before[2],after[1],after[2]].every(Number.isFinite))continue;
                    if(!((before[1]<=before[2]&&after[1]>after[2])||(before[1]>=before[2]&&after[1]<after[2])))continue;
                    const x=layout.t2screen(after[0]),y=layout.$2screen(after[1]);ctx.beginPath();ctx.moveTo(x-4,y-4);ctx.lineTo(x+4,y+4);ctx.moveTo(x-4,y+4);ctx.lineTo(x+4,y-4);ctx.stroke();
                }
                ctx.restore();
            }
        },
        use_for() { return ['Crossover'] },
        calc() {
            return {
                props: {
                    slowLength: { def: 13, text: 'Slow Length' },
                    fastLength: { def: 30, text: 'Fast Length' }
                },
                conf: { renderer: 'Channel' },
                update: `
                    let h = sma(close, slowLength)[0]
                    let m = sma(close, slowLength)[0]
                    let l = sma(close, fastLength)[0]
                    return [h, m, l]
                `
            }
        }
    }
}
</script>
